import {useCallback} from 'react';

import {DOWNLOAD_APP_URL} from '@/app/main/onboarding/pages/DownloadApp/models/constants';
import useWindowSize from '@/hooks/WindowSize/WindowSize';

export const useActions = () => {
  const {isMobile} = useWindowSize();

  const handleOpenDownloadApp = useCallback(() => {
    void window.open(DOWNLOAD_APP_URL, '_blank');
  }, []);

  return {
    isMobile,
    handleOpenDownloadApp,
  };
};
